export default function selectSingleElement<T extends HTMLElement>(selector: string, suppressError = false): T | null {
	const element = document.querySelector(selector);
	if (element === null) {
		if (!suppressError) {
			console.error(`Element with selector ${selector} not found`);
		}
		return null;
	}
	return document.querySelector(selector) as T;
}
